(() => {

    angular.module('filters')
        .filter('phoneCountryCode', (Countries) => {

            const dialCode = (() => {

                const dc = {};
                angular.forEach(Countries, (country) => {

                    dc[country.dialCode.substring(1)] = country.code;

                });

                return dc;

            })();

            return (phoneNumber) => {

                let countryCode;
                let prefix;
                let startIdx = 0;
                let n = 5;

                if (phoneNumber.charAt(0) === '+') {

                    startIdx = 1;

                } else if (phoneNumber.substring(0, 2) === '00') {

                    startIdx = 2;

                }

                while (!countryCode && n > 0) {

                    prefix = phoneNumber.substring(startIdx, n);

                    if (dialCode[prefix]) {

                        return dialCode[prefix];

                    }

                    n -= 1;

                }

                return '';

            };

        });

})();



// WEBPACK FOOTER //
// ./scripts/filters/phoneCountryCode.js